import React from "react";

const SoftwareHiTechLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section className="bg-[#ff7a6a] text-white">
                <div className="max-w-7xl mx-auto px-6 py-24 grid md:grid-cols-2 gap-12 items-center">
                    <div>
                        <span className="text-sm uppercase opacity-80">Industries</span>
                        <h1 className="text-4xl md:text-5xl font-bold mt-4">
                            Software & Hi-Tech
                        </h1>
                        <p className="mt-6 max-w-xl">
                            Building scalable, intelligent, and future-ready software platforms
                            for technology-driven enterprises.
                        </p>
                    </div>

                    <img
                        src="/images/industries/softwarehightech/hero.png"
                        alt="Software Engineering"
                        className="rounded-xl shadow-xl"
                    />
                </div>
            </section>

            {/* ================= INTRO ================= */}
            <section className="py-20">
                <div className="max-w-5xl mx-auto px-6 space-y-4 text-gray-700">
                    <p>
                        Software and Hi-Tech companies operate in a fast-changing environment
                        defined by rapid innovation, evolving customer expectations, and
                        intense competition.
                    </p>
                    <p>
                        We partner with technology leaders to modernize platforms, accelerate
                        product innovation, and scale engineering excellence using AI, cloud,
                        and automation.
                    </p>
                </div>
            </section>

            {/* ================= PRODUCT STRATEGY ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-10">
                    <div className="md:col-span-2">
                        <h2 className="text-3xl font-bold mb-4">
                            Product & Platform Strategy
                        </h2>
                        <p className="text-gray-700">
                            Align technology investments with business outcomes by defining
                            scalable product architectures, engineering roadmaps, and cloud-ready
                            platforms.
                        </p>

                        <button className="mt-6 bg-orange-500 text-white px-6 py-3 rounded-md">
                            Learn more about our service offerings
                        </button>
                    </div>

                    <div className="bg-[#020617] text-white rounded-xl p-6">
                        <h4 className="font-semibold mb-4">Our Offerings</h4>
                        <ul className="space-y-2 text-sm text-gray-300">
                            <li>• Product Engineering</li>
                            <li>• Platform Modernization</li>
                            <li>• Cloud-Native Development</li>
                            <li>• Data & AI Solutions</li>
                            <li>• SaaS Transformation</li>
                        </ul>
                    </div>
                </div>
            </section>

            {/* ================= RE(AI)MAGINING ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(2,6,23,.85), rgba(2,6,23,.85)), url(https://images.unsplash.com/photo-1518770660439-4636190af475)",
                    backgroundSize: "cover",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold">
                        Re(AI)magining™ Software & Hi-Tech
                    </h2>
                    <p className="mt-4 max-w-xl text-gray-200">
                        Apply AI-driven intelligence across product lifecycle management,
                        engineering productivity, and customer experiences.
                    </p>
                </div>
            </section>

            {/* ================= SERVICE GRID ================= */}
            <section className="py-20 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">
                        Leveraging the Strength of Our Service Lines
                    </h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[
                            "Product Engineering",
                            "Platform Modernization",
                            "Cloud & DevOps",
                            "Data & Analytics",
                            "AI & Intelligent Automation",
                            "Cybersecurity",
                            "Experience Transformation",
                            "SaaS Enablement",
                            "Enterprise Integration",
                        ].map((item) => (
                            <div
                                key={item}
                                className="bg-white rounded-xl shadow-sm p-6 text-sm font-medium"
                            >
                                {item}
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= AWARDS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">
                        Awards & Recognitions
                    </h2>

                    {/*
      👉 Each award has different image + text
    */}
                    {[
                        {
                            img: "https://images.unsplash.com/photo-1581092918056-0c4c3acd3789",
                            title: "Recognized for engineering excellence and innovation",
                        },
                        {
                            img: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
                            title: "Awarded for outstanding infrastructure development",
                        },
                        {
                            img: "https://images.unsplash.com/photo-1521737604893-d14cc237f11d",
                            title: "Honored for sustainable and smart construction solutions",
                        },
                    ].map((award, i) => (
                        <div
                            key={i}
                            className="bg-white text-black rounded-xl overflow-hidden"
                        >
                            <img
                                src={award.img}
                                alt="Award"
                                className="w-full h-48 object-cover"
                            />

                            <div className="p-5">
                                <p className="font-medium">{award.title}</p>

                                <button className="mt-3 text-orange-600 text-sm">
                                    Learn more →
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            </section>


            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-6">
                        {[1, 2, 3].map((i) => (
                            <div key={i} className="bg-white text-black rounded-xl p-6">
                                <p className="font-medium">
                                    Helping a global technology leader scale engineering velocity
                                </p>
                                <button className="mt-4 text-orange-600 text-sm">
                                    Read the story →
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= WHY PERSISTENT ================= */}
            <section className="py-20 bg-[#fde8db]">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-3 gap-8">
                    <div>
                        <h4 className="font-semibold mb-2">Product Engineering DNA</h4>
                        <p className="text-sm">
                            Decades of experience building and scaling global software products.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">Platform Innovation</h4>
                        <p className="text-sm">
                            Expertise across cloud, AI, data, and modern engineering practices.
                        </p>
                    </div>
                    <div>
                        <h4 className="font-semibold mb-2">Robust Execution Framework</h4>
                        <p className="text-sm">
                            Proven delivery models that accelerate time-to-value.
                        </p>
                    </div>
                </div>
            </section>

            {/* ================= CONTACT ================= */}
            

        </div>
    );
};

export default SoftwareHiTechLayout;
